import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-links',
  templateUrl: '../../../../assets/html/fabrikanten_links.html',
  styleUrls: ['./links.component.css']
})
export class LinksComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var t = $('[data-parallax="scroll"]').data('imageSrc');
    $('[data-parallax="scroll"]').parallax({imageSrc: t});
  }

}
